var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinnerYellow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 84,
  height: 84,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 42,
  r: 35,
  stroke: "#EDEDED",
  strokeWidth: 13
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E9D800",
  d: "M52.095 1.746a6.5 6.5 0 0 0-3.163 12.61zm15.314 53.161a6.5 6.5 0 1 0 11.59 5.888zM48.932 14.356A28.5 28.5 0 0 1 60.24 20.1l8.32-9.989a41.5 41.5 0 0 0-16.465-8.366zM60.24 20.1a28.5 28.5 0 0 1 7.694 10.082l11.83-5.39a41.5 41.5 0 0 0-11.204-14.68zm7.694 10.082a28.5 28.5 0 0 1 2.559 12.422l12.997.277a41.5 41.5 0 0 0-3.726-18.089zm2.559 12.422a28.5 28.5 0 0 1-3.084 12.303l11.59 5.887a41.5 41.5 0 0 0 4.491-17.913z"
})));
export default SvgSpinnerYellow;